import { useEffect } from 'react';
import { useQueryClient } from 'react-query';

import useMeetingsNotifications from '../hooks/useMeetingsNotifications';
import { useMeetings } from '../MeetingsTool/MeetingsToolContext';
import { MeetingsHttpKey } from '../ManageMeetings/useMeetingsData';

const useUpdateMeetingsOnNewNotifications = () => {
    const queryClient = useQueryClient();
    const { eventUniqueName } = useMeetings();
    const { hasNewNotification, resetNotification } = useMeetingsNotifications({
        eventUniqueName,
        notificationsOnMount: false,
    });

    useEffect(() => {
        if (hasNewNotification) {
            queryClient.invalidateQueries(MeetingsHttpKey.Meetings);
            resetNotification();
        }
    }, [queryClient, hasNewNotification]);
};

export default useUpdateMeetingsOnNewNotifications;
